module.exports = __webpack_public_path__ + "b93a1d82fbac2ce80e10344eff5fa1ca.MP3";